import { NavItem } from '../../nav/primitives/nav-item';
import { useScheduleNavItem } from './use-schedule-nav-item';

export const ScheduleNavItem = () => {
  const item = useScheduleNavItem();
  return <NavItem item={item} />;
};
